import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import PremiumProtectionHero from "./sections/PremiumProtectionHero";
import OurCredentials from "./sections/OurCredentials";
import ComprehensivePestSolutions from "./sections/ComprehensivePestSolutions";
import TheAtticToBasementDifference from "./sections/TheAtticToBasementDifference";
import ServingTheTriangle from "./sections/ServingTheTriangle";
import SecureYourFreeInspection from "./sections/SecureYourFreeInspection";
import SiteFooter from "@/reusable_sections/Footer";
import Premiumtrustreviews from "./sections/Premiumtrustreviews";
import ProtectionPlansComparison from "./sections/ProtectionPlansComparison";
import GoogleReviews from "./sections/GoogleReviews";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <PremiumProtectionHero />
      <ProtectionPlansComparison />
      <GoogleReviews />
      <OurCredentials />
      <ComprehensivePestSolutions />
      <TheAtticToBasementDifference />
      <Premiumtrustreviews />
      <ServingTheTriangle />
      <SecureYourFreeInspection />
      <SiteFooter />
    </div>;
}